import SparkMD5 from "spark-md5"

export function escapeHTML(html) {
    const escape = document.createElement('textarea');
    escape.textContent = html;
    return escape.innerHTML;
}

export function get_date(dateString) {
    const date = new Date(dateString), now = new Date(), hours = (now.getTime() - date.getTime()) / (60 * 60 * 1000), days = hours / 24
    if (hours < 24) {
        return moment(dateString).format('hh:mm A')
    }
    if (days > 300) {
        return moment(dateString).format('MM/DD/YYYY')
    }
    return moment(dateString).format('MMM DD')
}

export function get_file_extension(name = '') {
    if (name) {
        const s = name.split('.')
        if (s.length > 1) {
            return s[1]
        }
    }
    return ''
}

export const is_email_valid = (email) => /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email)

export function md5_from_base64(base64Data) {
    const array = Uint8Array.from(window.atob(base64Data), c => c.charCodeAt(0))
        , spark = new SparkMD5.ArrayBuffer()
    spark.append(array.buffer)
    return spark.end()
}

export function split_emails(emails_string) {
    let email = '', emails = [], within_name = false
    for (let index = 0; index < emails_string.length; index++) {
        const char = emails_string[index]
        if (char === '"') {
            within_name = !within_name
        }
        if (char === ',' && !within_name) {
            emails.push(email.trim())
            email = ''
        } else {
            email += char
        }
    }
    if(email) {
        emails.push(email.trim())
    }
    return emails
}

export function split_fullname(fullname = '') {
    const a = fullname.split(' ')
    let first_name = '', last_name = ''
    if (a.length) {
        first_name = a[0]
        last_name = a.slice(1, a.length).join(' ')
    }
    return [first_name, last_name]
}
